module.exports = "/_next/static/images/ec01e0ff396810c65b15574a21310b94-qr-to-app-v2.svg.webp";